import ActionBar from '../../../components/ActionBar/NewActionBar';
import Button from '../../../components/Button/Button';
import Constants from 'expo-constants';
import InfoCard from '../../../components/InfoCard/InfoCard';
import Loading from '../../../components/Loading/Loading';
import Show from '../../../components/Show/Show';
import { AppointmentCard } from '../../../components/Assistance/AppointmentCard/AppointmentCard';
import { COLORS } from '../../../config/designSystem/Colors';
import { FC, useState } from 'react';
import { H1 } from '../../../config/designSystem/typography';
import { SPACING } from '../../../config/designSystem/Spacing';
import { ScrollView, StyleSheet, View } from 'react-native';
import { StatusBar } from 'expo-status-bar';
import { WPO_CANCEL_APPOINTMENT } from '../../../state/mutations/User';
import { assistanceKey } from '../../../constants/routeKeys';
import { captureException } from '@sentry/react-native';
import { concatPath } from '../../../utils/links/concatPath';
import { isWeb } from '../../../config/designSystem/Layout';
import { logAmplitude } from '../../../utils/analytics/analytics';
import { observer } from 'mobx-react';
import { router } from 'expo-router';
import { useMutation } from '@apollo/client';
import { useStores } from '../../../hooks/useStores';


const YourNextAppointment: FC = () => {
  const { language: languageStore, user } = useStores();
  const labels = languageStore.translate.MOBILE.ASSISTANCE;
  const [cancellingId, setCancellingId] = useState<number | undefined>();
  const [cancelAppointment, cancelResult] = useMutation(WPO_CANCEL_APPOINTMENT);
  const goToAssistance = () => {
    router.navigate(concatPath([assistanceKey]) as string);
  };
  const onPressCancel = (appointmentId: number, companyId: string) => {
    logAmplitude('Wpo Appointment Cancelled');
    setCancellingId(appointmentId);
    cancelAppointment({
      variables: {
        input: {
          appointmentId: `${appointmentId}`,
          companyId,
        }
      },
      onError: error => {
        console.error(error);
        captureException(error);
        setCancellingId(undefined);
      },
      onCompleted: async () => {
        await user.wpoAppointments.fetch();
        setCancellingId(undefined);
        if (!user.wpoAppointments.hasAny) {
          goToAssistance();
        }
      }
    });
  };
  return (
    <View style={styles.Frame}>
      <StatusBar style="dark" />
      <ActionBar
        width='100%'
        height={40}
        title={labels?.THERAPY_SCHEDULE_A_SESSION}
        onExit={goToAssistance}
        onPrevious={goToAssistance}
      />
      <H1>{labels?.YOUR_NEXT_APPT}</H1>
      <ScrollView contentContainerStyle={{paddingBottom: SPACING['sp-32']}}>
        {user.wpoAppointments.sorted.map(appointment => {
          const isCancellingThis = cancelResult.loading && cancellingId === appointment.appointmentId;
          return (
            <View key={appointment.appointmentId} style={{marginBottom: SPACING['sp-24']}}>
              <AppointmentCard
                appointmentModeLabelKey={appointment.appointmentModeLabel}
                counsellorName={appointment.counsellorName}
                locale={languageStore.language}
                date={appointment.dateFrom}
                timeZone={appointment.timeZone}
              />
              <View style={{display: 'flex', flexDirection: 'column'}}>
                <Show
                  when={!isCancellingThis}
                  fallback={
                    <View style={{padding: SPACING['sp-32']}}>
                      <Loading />
                    </View>
                  }
                >
                  <Button
                    label={labels?.APPOINTMENT?.CANCEL}
                    onPress={() => onPressCancel(appointment.appointmentId, `${appointment.companyId}`)}
                    leadingIcon='x'
                    backgroundColor='transparent'
                    color={COLORS.state.danger.primary}
                    height={SPACING['sp-32']}
                    paddingHorizontal={SPACING['sp-8']}
                    paddingVertical={SPACING['sp-4']}
                  />
                </Show>
              </View>
            </View>
          );
        })}
        <Show when={cancelResult.error} keyed>
          {error => (
            <View style={{maxWidth: 300}}>
              <InfoCard
                info={error.message}
                type='error'
              />
            </View>
          )}
        </Show>
      </ScrollView>
    </View>
  );
};

export const styles = StyleSheet.create({
  Frame: {
    flex: 1,
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginTop: isWeb ? 0 : Constants.statusBarHeight,
    marginBottom: isWeb ? 0 : 32,
    marginHorizontal: 16,
    backgroundColor: COLORS.surface.primary,
    opacity: 1,
  }
});

export default observer(YourNextAppointment);


